import type { DerivedBanhangPalette } from '@/theme/deriveAccentPalette'

/** Đồng bộ token bảng / cột đọc từ `tableListTokens` (var + fallback). */
export function applyBanhangCssVars(d: DerivedBanhangPalette): void {
  if (typeof document === 'undefined') return
  const s = document.documentElement.style
  s.setProperty('--banhang-primary', d.primaryMain)
  s.setProperty('--banhang-primary-dark', d.primaryDark)
  s.setProperty('--banhang-primary-light', d.primaryLight)
  s.setProperty('--banhang-header-bg', d.headerBg)
  /** Chrome POS / header modal phiếu (đặt hàng, hóa đơn…) — đậm hơn header. */
  s.setProperty('--banhang-pos-chrome-bg', d.navItemActiveBg)
  s.setProperty('--banhang-nav-active-bg', d.navItemActiveBg)
  s.setProperty('--banhang-nav-active-hover-bg', d.navItemActiveBgHover)
  s.setProperty('--banhang-submenu-bg', d.kiotSubmenuPanelBg)
  s.setProperty('--banhang-invoice-thead-bg', d.invoiceTableHeaderBg)
  s.setProperty('--banhang-table-level2-head-bg', d.tableLevel2HeadBg)
  s.setProperty('--banhang-table-level2-head-border', d.tableLevel2HeadBorder)
  s.setProperty('--banhang-table-head-bg', d.tableHeadBg)
  s.setProperty('--banhang-table-head-border', d.tableHeadBorder)
  s.setProperty('--banhang-table-wrapper-border', d.tableWrapperBorder)
  s.setProperty('--banhang-row-alt-bg', d.rowAltBg)
  s.setProperty('--banhang-row-hover-bg', d.rowHoverBg)
  s.setProperty('--banhang-row-selected-bg', d.rowSelectedBg)
  s.setProperty('--banhang-row-selected-hover-bg', d.rowSelectedHoverBg)
  s.setProperty('--banhang-primary-surface', d.primarySurface)
  s.setProperty('--banhang-primary-surface-border', d.primarySurfaceBorder)
}
